import posthog from 'posthog-js';

const SIGNUP_PATH = '/signup';
const SUPPORTED_UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

function capture(eventName, properties = {}) {
  if (!process.env.REACT_APP_POSTHOG_KEY) {
    return;
  }

  if (typeof window !== 'undefined' && window.location.pathname === '/glp1-bridge') {
    return;
  }

  posthog.capture(eventName, {
    page_path: window.location.pathname,
    ...properties,
  });
}

function getCurrentSearch() {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.search;
}

function getUtmProperties(search = getCurrentSearch()) {
  const currentParams = new URLSearchParams(search);
  const properties = {};

  SUPPORTED_UTM_PARAMS.forEach((paramName) => {
    const value = currentParams.get(paramName);

    if (value) {
      properties[paramName] = value;
    }
  });

  return properties;
}

export function captureCtaClick(ctaName, properties = {}) {
  capture('cta_click', {
    cta_name: ctaName,
    ...properties,
  });
}

export function captureCalendlyEvent(eventName, properties = {}) {
  capture(eventName, properties);
}

export function captureResourceOpen(resourceSlug, properties = {}) {
  capture('resource_open', {
    resource_slug: resourceSlug,
    ...properties,
  });
}

export function captureOutboundLinkClick(linkName, destination, properties = {}) {
  capture('outbound_link_click', {
    link_name: linkName,
    destination,
    ...properties,
  });
}

const SIGNUP_REF_KEY = 'medhug_signup_ref';

function getNavigationType() {
  if (typeof window === 'undefined' || typeof window.performance?.getEntriesByType !== 'function') {
    return null;
  }

  const [navigationEntry] = window.performance.getEntriesByType('navigation');

  return navigationEntry?.type || null;
}

export function buildSignupTrackingProperties(search = getCurrentSearch(), state = null) {
  const currentParams = new URLSearchParams(search);
  let ref = state?.signupRef;

  if (!ref) {
    ref = currentParams.get('ref');
  }

  if (ref) {
    try { sessionStorage.setItem(SIGNUP_REF_KEY, ref); } catch {}
  } else if (getNavigationType() === 'reload') {
    try { ref = sessionStorage.getItem(SIGNUP_REF_KEY); } catch {}
  }

  return {
    ref: ref || 'direct-signup',
    ...getUtmProperties(search),
  };
}

export function buildSignupState(ref) {
  return ref ? { signupRef: ref } : null;
}

export function clearSignupTrackingRef() {
  try {
    sessionStorage.removeItem(SIGNUP_REF_KEY);
  } catch {}
}

export function buildSignupPath(search = getCurrentSearch()) {
  const nextParams = new URLSearchParams();

  Object.entries(getUtmProperties(search)).forEach(([paramName, value]) => {
    nextParams.set(paramName, value);
  });

  const queryString = nextParams.toString();

  return queryString ? `${SIGNUP_PATH}?${queryString}` : SIGNUP_PATH;
}
